// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"707":"60d95602","1061":"60d95602","2896":"60d95602","6283":"60d95602","8070":"60d95602"}[chunkId] + ".chunk.css";
};